import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer uploadExcelModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "my-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = { class: "d-flex align-items-center flex-wrap mb-3" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = { class: "d-flex align-items-center flex-wrap mb-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "col-sm-12" }
const _hoisted_16 = { class: "d-flex align-items-center flex-wrap mb-3" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = { class: "d-flex align-items-center flex-wrap mb-3" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "d-flex align-items-center justify-content-center mt-5" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Multiple deleting",
          text: "Multiple deleting"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_localized_text, {
              localizedKey: "Scopes",
              text: "Scopes",
              class: "d-block mb-2 pb-1 fw_700"
            }),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableScopes, (scope) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["btn me-2 mb-2", _ctx.model.scopes.findIndex(x => x == scope) > -1 ? 'btn-tertiary': 'btn-secondary withBorder']),
                  onClick: ($event: any) => (_ctx.toggleScope(scope)),
                  key: scope
                }, [
                  _createElementVNode("span", null, _toDisplayString(scope), 1)
                ], 10, _hoisted_11))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_localized_text, {
              localizedKey: "Years",
              text: "Years",
              class: "d-block mb-2 pb-1 fw_700"
            }),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableYears, (year) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["btn me-2 mb-2", _ctx.model.years.findIndex(x => x == parseInt(year)) > -1 ? 'btn-tertiary': 'btn-secondary withBorder']),
                  onClick: ($event: any) => (_ctx.toggleYear(year)),
                  key: year
                }, [
                  _createElementVNode("span", null, _toDisplayString(year), 1)
                ], 10, _hoisted_14))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_localized_text, {
              localizedKey: "Premises",
              text: "Premises",
              class: "d-block mb-2 pb-1 fw_700"
            }),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePremises, (premises) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["btn me-2 mb-2", _ctx.model.premises.findIndex(x => x == premises) > -1 ? 'btn-tertiary': 'btn-secondary withBorder']),
                  onClick: ($event: any) => (_ctx.togglePremises(premises)),
                  key: premises
                }, [
                  _createElementVNode("span", null, _toDisplayString(premises), 1)
                ], 10, _hoisted_17))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_localized_text, {
              localizedKey: "Categories",
              text: "Categories",
              class: "d-block mb-2 pb-1 fw_700"
            }),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCategories, (category) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["btn me-2 mb-2", _ctx.model.categories.findIndex(x => x == category) > -1 ? 'btn-tertiary': 'btn-secondary withBorder']),
                  onClick: ($event: any) => (_ctx.toggleCategory(category)),
                  key: category
                }, [
                  _createElementVNode("span", null, _toDisplayString(category), 1)
                ], 10, _hoisted_20))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteSelected()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Delete selected",
            text: "Delete selected"
          })
        ], 8, _hoisted_22),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary ms-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteAll()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Delete all",
            text: "Delete all"
          })
        ])
      ])
    ])
  ]))
}